/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".clickable[_ngcontent-%COMP%]{cursor:pointer}.pheader[_ngcontent-%COMP%]{color:#004aad;font-size:1.5em}.ui-g[_ngcontent-%COMP%]{display:block}[pdf-viewer-update-enabled][_nghost-%COMP%]{display:block;flex-direction:column;height:80%;width:50%}@media screen{#print-content[_ngcontent-%COMP%], .print-content[_ngcontent-%COMP%]{display:none!important;visibility:hidden!important}}.p-dialog-width[_ngcontent-%COMP%]{width:50vw}html[_ngcontent-%COMP%]{font-family:Montserrat,sans-serif!important}"];
export { styles as styles };

